// src/pages/membres/ModifierMembre.jsx
import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import Header from '../../layouts/Header';
import Footer from '../../layouts/Footer';
import { COLORS } from '../../constants/colors';

const styles = `
  .dashboard-styled {
    background: #f4f6f9;
    min-height: 100vh;
  }

  /* En-tête moderne */
  .header-modern {
    background: white;
    padding: 1.2rem 1.8rem;
    box-shadow: 0 2px 8px rgba(0,0,0,0.04);
    border-left: 4px solid ${COLORS.secondary};
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .header-left {
    display: flex;
    align-items: center;
    gap: 1rem;
  }

  .header-icon-wrapper {
    width: 48px;
    height: 48px;
    background: ${COLORS.primary};
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    color: white;
    font-size: 1.4rem;
  }

  .gradient-text {
    color: #1e293b;
    font-size: 1.3rem;
    font-weight: 700;
    margin: 0;
  }

  .badge-modern {
    background: #f1f4f9;
    color: #475569;
    padding: 0.3rem 0.8rem;
    border-radius: 4px;
    font-size: 0.75rem;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }
  .badge-modern i {
    color: ${COLORS.secondary};
  }

  .btn-modern-outline {
    border: 1px solid #d1d5db;
    background: white;
    padding: 0.4rem 1.2rem;
    border-radius: 4px;
    font-size: 0.85rem;
    font-weight: 500;
    color: #4b5563;
    transition: all 0.2s;
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }
  .btn-modern-outline:hover {
    border-color: ${COLORS.secondary};
    color: ${COLORS.secondary};
    background: #fafafa;
  }

  .btn-modern-primary {
    background: ${COLORS.primary};
    border: none;
    padding: 0.4rem 1.2rem;
    border-radius: 4px;
    font-size: 0.85rem;
    font-weight: 500;
    color: white;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    transition: all 0.2s;
  }
  .btn-modern-primary:hover {
    background: ${COLORS.primaryDark};
    box-shadow: 0 4px 10px rgba(41,90,167,0.3);
  }

  .btn-modern-success {
    background: ${COLORS.success};
    border: none;
    padding: 0.4rem 1.2rem;
    border-radius: 4px;
    font-size: 0.85rem;
    font-weight: 500;
    color: white;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    transition: all 0.2s;
  }
  .btn-modern-success:hover {
    background: #059669;
    box-shadow: 0 4px 10px rgba(16,185,129,0.3);
  }

  /* Card */
  .card-modern {
    border: none;
    border-radius: 4px;
    background: white;
    box-shadow: 0 2px 6px rgba(0,0,0,0.04);
    border-top: 3px solid transparent;
    transition: box-shadow 0.2s;
  }
  .card-modern:hover {
    box-shadow: 0 4px 12px rgba(0,0,0,0.06);
  }
  .card-modern.border-primary {
    border-top-color: ${COLORS.primary};
  }
  .card-modern.border-secondary {
    border-top-color: ${COLORS.secondary};
  }

  .card-header-modern {
    background: transparent;
    border-bottom: 1px solid #e9edf2;
    padding: 0.8rem 1.2rem;
    font-weight: 600;
    color: #1e293b;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
  .card-header-modern i {
    color: ${COLORS.secondary};
  }

  .card-body-modern {
    padding: 1.5rem;
  }

  /* Notifications */
  .toast-notification {
    padding: 0.8rem 1rem;
    border: none;
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-bottom: 1.5rem;
    animation: slideDown 0.3s ease-out;
    border-radius: 4px;
  }

  .toast-notification-success {
    background: #f0fdf4;
    border-left: 3px solid ${COLORS.success};
  }

  .toast-notification-error {
    background: #fef2f2;
    border-left: 3px solid ${COLORS.danger};
  }

  .toast-icon {
    width: 28px;
    height: 28px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    font-size: 1rem;
  }

  .toast-icon-success {
    background: rgba(16, 185, 129, 0.15);
    color: ${COLORS.success};
  }

  .toast-icon-error {
    background: rgba(239, 68, 68, 0.15);
    color: ${COLORS.danger};
  }

  .toast-content {
    flex: 1;
  }

  .toast-title {
    font-size: 0.8rem;
    font-weight: 600;
    margin-bottom: 1px;
  }

  .toast-message {
    font-size: 0.75rem;
    color: #64748b;
    margin: 0;
  }

  .toast-close {
    background: none;
    border: none;
    color: #94a3b8;
    cursor: pointer;
    padding: 2px;
    font-size: 1rem;
    transition: color 0.2s;
  }
  .toast-close:hover {
    color: #475569;
  }

  /* Form */
  .form-label-modern {
    font-size: 0.7rem;
    font-weight: 600;
    color: #475569;
    margin-bottom: 0.2rem;
  }

  .form-label-modern .required {
    color: ${COLORS.danger};
    margin-left: 2px;
  }

  .form-control-modern {
    border: 1px solid #e2e8f0;
    border-radius: 4px;
    padding: 0.4rem 0.7rem;
    font-size: 0.85rem;
    transition: all 0.2s ease;
    background: white;
  }

  .form-control-modern:focus {
    border-color: ${COLORS.primary};
    box-shadow: 0 0 0 3px rgba(41, 90, 167, 0.08);
  }

  .form-control-modern.is-invalid {
    border-color: ${COLORS.danger};
  }

  .form-control-modern.is-invalid:focus {
    box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.08);
  }

  .form-select-modern {
    border: 1px solid #e2e8f0;
    border-radius: 4px;
    padding: 0.4rem 0.7rem;
    font-size: 0.85rem;
    transition: all 0.2s ease;
    background: white;
  }

  .form-select-modern:focus {
    border-color: ${COLORS.primary};
    box-shadow: 0 0 0 3px rgba(41, 90, 167, 0.08);
  }

  .form-text-modern {
    font-size: 0.65rem;
    color: #94a3b8;
    margin-top: 0.2rem;
  }

  .section-title {
    font-size: 0.85rem;
    font-weight: 600;
    color: ${COLORS.primaryDark};
    margin-bottom: 0.75rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
  .section-title i {
    color: ${COLORS.secondary};
  }

  hr {
    border: none;
    border-top: 1px solid #e9edf2;
    margin: 1.5rem 0;
  }

  /* Animations */
  @keyframes slideDown {
    from { opacity: 0; transform: translateY(-8px); }
    to { opacity: 1; transform: translateY(0); }
  }

  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(6px); }
    to { opacity: 1; transform: translateY(0); }
  }

  .fade-in {
    animation: fadeIn 0.3s ease-out;
  }

  @media (max-width: 768px) {
    .header-modern {
      flex-direction: column;
      align-items: stretch;
      gap: 0.8rem;
      padding: 1rem;
    }
    .header-left {
      flex-wrap: wrap;
    }
    .card-body-modern {
      padding: 1rem;
    }
  }
`;

export default function ModifierMembre() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [fetchLoading, setFetchLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [emailError, setEmailError] = useState('');

  const [formData, setFormData] = useState({
    nom: '',
    prenom: '',
    datenaiss: '',
    lieunaiss: '',
    contact: '',
    email: '',
    nb_enf: 0,
    situtaion_maritale: 'Célibataire',
    date_bapt_eau: '',
    date_bapt_saint: '',
    form_seculiere: '',
    form_eccle: '',
    date_consecration: '',
    lieu_affectation: '',
    fonct_org: '',
    date_depart: '',
    role: 'Membre',
    gendre: 'Homme'
  });

  useEffect(() => {
    fetchMembre();
  }, [id]);

  const fetchMembre = async () => {
    try {
      setFetchLoading(true);
      const userStr = localStorage.getItem('user');
      if (!userStr) {
        navigate('/pages/signin2');
        return;
      }

      const user = JSON.parse(userStr);
      const userId = user.id || user.id_utilisateur;

      const response = await fetch(`https://josephsbusiness.com/api/membre_details.php?user_id=${userId}&id=${id}`, {
        headers: { 'Accept': 'application/json' }
      });

      const result = await response.json();

      if (result.success) {
        const membre = result.membre;
        setFormData({
          nom: membre.nom || '',
          prenom: membre.prenom || '',
          datenaiss: membre.datenaiss || '',
          lieunaiss: membre.lieunaiss || '',
          contact: membre.contact || '',
          email: membre.email || '',
          nb_enf: membre.nb_enf || 0,
          situtaion_maritale: membre.situtaion_maritale || 'Célibataire',
          date_bapt_eau: membre.date_bapt_eau || '',
          date_bapt_saint: membre.date_bapt_saint || '',
          form_seculiere: membre.form_seculiere || '',
          form_eccle: membre.form_eccle || '',
          date_consecration: membre.date_consecration || '',
          lieu_affectation: membre.lieu_affectation || '',
          fonct_org: membre.fonct_org || '',
          date_depart: membre.date_depart || '',
          role: membre.role || 'Membre',
          gendre: membre.gendre || 'Homme'
        });
      } else {
        setError(result.message || 'Erreur de chargement');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setFetchLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'email') {
      setEmailError('');
    }

    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setEmailError('');

    try {
      const userStr = localStorage.getItem('user');
      if (!userStr) {
        navigate('/pages/signin2');
        return;
      }

      const user = JSON.parse(userStr);
      const userId = user.id || user.id_utilisateur;

      const response = await fetch(`https://josephsbusiness.com/api/membres.php?user_id=${userId}&id=${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      const result = await response.json();

      if (result.success) {
        setSuccess('Membre modifié avec succès');
        setTimeout(() => {
          navigate('/membres/liste');
        }, 2000);
      } else {
        if (result.message && result.message.includes('email')) {
          setEmailError(result.message);
        } else {
          setError(result.message || 'Erreur lors de la modification');
        }
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (fetchLoading) {
    return (
      <>
        <Header />
        <div className="main main-app p-3 p-lg-4 dashboard-styled">
          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
            <div className="text-center">
              <div className="loading-ring-wrapper mb-3">
                <div className="loading-ring"></div>
                <div className="loading-ring-inner"></div>
              </div>
              <h5 className="fw-bold" style={{ color: COLORS.primaryDark }}>Chargement...</h5>
              <p className="text-muted small">Récupération des informations</p>
            </div>
          </div>
          <style>{`
            .loading-ring-wrapper { position: relative; width: 70px; height: 70px; margin: 0 auto; }
            .loading-ring { position: absolute; width: 100%; height: 100%; border-radius: 50%; border: 3px solid #e9edf2; border-top-color: ${COLORS.primary}; animation: spin 0.8s linear infinite; }
            .loading-ring-inner { position: absolute; top: 8px; left: 8px; right: 8px; bottom: 8px; border-radius: 50%; border: 2px solid #e9edf2; border-bottom-color: ${COLORS.secondary}; animation: spin 0.6s linear infinite reverse; }
            @keyframes spin { to { transform: rotate(360deg); } }
          `}</style>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <style>{styles}</style>
      <Header />
      <div className="main main-app p-3 p-lg-4 dashboard-styled">
        <div className="container-fluid px-0">

          {/* En-tête */}
          <div className="header-modern mb-4 fade-in">
            <div className="header-left">
              <div className="header-icon-wrapper">
                <i className="ri-edit-line"></i>
              </div>
              <div>
                <h5 className="gradient-text">Modifier le membre</h5>
                <div className="d-flex flex-wrap gap-2">
                  <span className="badge-modern">
                    <i className="ri-user-line"></i> {formData.prenom} {formData.nom}
                  </span>
                  <span className="badge-modern">
                    <i className="ri-calendar-line"></i> Mis à jour aujourd'hui
                  </span>
                </div>
              </div>
            </div>
            <Button
              variant="outline-secondary"
              size="sm"
              className="btn-modern-outline"
              onClick={() => navigate(-1)}
            >
              <i className="ri-arrow-left-line"></i> Retour
            </Button>
          </div>

          {/* Card principale */}
          <Row className="justify-content-center">
            <Col md={10} lg={9}>
              <Card className="card-modern border-primary">
                <Card.Header className="card-header-modern">
                  <i className="ri-pencil-line"></i> Formulaire de modification
                </Card.Header>
                <Card.Body className="card-body-modern">

                  {/* Notifications */}
                  {error && (
                    <div className="toast-notification toast-notification-error">
                      <div className="toast-icon toast-icon-error">
                        <i className="ri-error-warning-line"></i>
                      </div>
                      <div className="toast-content">
                        <div className="toast-title" style={{ color: COLORS.danger }}>Erreur</div>
                        <p className="toast-message">{error}</p>
                      </div>
                      <button className="toast-close" onClick={() => setError('')}>
                        <i className="ri-close-line"></i>
                      </button>
                    </div>
                  )}

                  {emailError && (
                    <div className="toast-notification toast-notification-error">
                      <div className="toast-icon toast-icon-error">
                        <i className="ri-mail-close-line"></i>
                      </div>
                      <div className="toast-content">
                        <div className="toast-title" style={{ color: COLORS.danger }}>Erreur d'email</div>
                        <p className="toast-message">{emailError}</p>
                      </div>
                      <button className="toast-close" onClick={() => setEmailError('')}>
                        <i className="ri-close-line"></i>
                      </button>
                    </div>
                  )}

                  {success && (
                    <div className="toast-notification toast-notification-success">
                      <div className="toast-icon toast-icon-success">
                        <i className="ri-checkbox-circle-line"></i>
                      </div>
                      <div className="toast-content">
                        <div className="toast-title" style={{ color: COLORS.success }}>Succès</div>
                        <p className="toast-message">{success}</p>
                      </div>
                      <button className="toast-close" onClick={() => setSuccess('')}>
                        <i className="ri-close-line"></i>
                      </button>
                    </div>
                  )}

                  {/* Formulaire */}
                  <Form onSubmit={handleSubmit}>
                    <Row className="g-3">

                      {/* Section Identité */}
                      <Col md={12}>
                        <div className="section-title">
                          <i className="ri-user-line"></i> Identité
                        </div>
                      </Col>

                      <Col md={6}>
                        <Form.Group controlId="nom">
                          <Form.Label className="form-label-modern">
                            Nom <span className="required">*</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="nom"
                            value={formData.nom}
                            onChange={handleChange}
                            required
                            className="form-control-modern"
                          />
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group controlId="prenom">
                          <Form.Label className="form-label-modern">
                            Prénom <span className="required">*</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="prenom"
                            value={formData.prenom}
                            onChange={handleChange}
                            required
                            className="form-control-modern"
                          />
                        </Form.Group>
                      </Col>

                      <Col md={4}>
                        <Form.Group controlId="gendre">
                          <Form.Label className="form-label-modern">
                            Genre <span className="required">*</span>
                          </Form.Label>
                          <Form.Select
                            name="gendre"
                            value={formData.gendre}
                            onChange={handleChange}
                            required
                            className="form-select-modern"
                          >
                            <option value="Homme">Homme</option>
                            <option value="Femme">Femme</option>
                            <option value="Enfant">Enfant</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>

                      <Col md={4}>
                        <Form.Group controlId="role">
                          <Form.Label className="form-label-modern">
                            Rôle <span className="required">*</span>
                          </Form.Label>
                          <Form.Select
                            name="role"
                            value={formData.role}
                            onChange={handleChange}
                            required
                            className="form-select-modern"
                          >
                            <option value="Pasteur">Pasteur</option>
                            <option value="Ancien">Ancien</option>
                            <option value="Diacre">Diacre</option>
                            <option value="Diaconesse">Diaconesse</option>
                            <option value="Jeune">Jeune</option>
                            <option value="Nouveau">Nouveau</option>
                            <option value="Membre">Membre</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>

                      <Col md={4}>
                        <Form.Group controlId="situtaion_maritale">
                          <Form.Label className="form-label-modern">Situation matrimoniale</Form.Label>
                          <Form.Select
                            name="situtaion_maritale"
                            value={formData.situtaion_maritale}
                            onChange={handleChange}
                            className="form-select-modern"
                          >
                            <option value="Célibataire">Célibataire</option>
                            <option value="Marié(e)">Marié(e)</option>
                            <option value="Divorcé(e)">Divorcé(e)</option>
                            <option value="Veuf(ve)">Veuf(ve)</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>

                      <hr />

                      {/* Section Naissance */}
                      <Col md={12}>
                        <div className="section-title">
                          <i className="ri-cake-line"></i> Naissance
                        </div>
                      </Col>

                      <Col md={4}>
                        <Form.Group controlId="datenaiss">
                          <Form.Label className="form-label-modern">Date de naissance</Form.Label>
                          <Form.Control
                            type="date"
                            name="datenaiss"
                            value={formData.datenaiss}
                            onChange={handleChange}
                            className="form-control-modern"
                          />
                        </Form.Group>
                      </Col>

                      <Col md={4}>
                        <Form.Group controlId="lieunaiss">
                          <Form.Label className="form-label-modern">Lieu de naissance</Form.Label>
                          <Form.Control
                            type="text"
                            name="lieunaiss"
                            value={formData.lieunaiss}
                            onChange={handleChange}
                            className="form-control-modern"
                          />
                        </Form.Group>
                      </Col>

                      <Col md={4}>
                        <Form.Group controlId="nb_enf">
                          <Form.Label className="form-label-modern">Nombre d'enfants</Form.Label>
                          <Form.Control
                            type="number"
                            name="nb_enf"
                            value={formData.nb_enf}
                            onChange={handleChange}
                            min="0"
                            className="form-control-modern"
                          />
                        </Form.Group>
                      </Col>

                      <hr />

                      {/* Section Contact */}
                      <Col md={12}>
                        <div className="section-title">
                          <i className="ri-contacts-line"></i> Contact
                        </div>
                      </Col>

                      <Col md={6}>
                        <Form.Group controlId="contact">
                          <Form.Label className="form-label-modern">Téléphone</Form.Label>
                          <Form.Control
                            type="text"
                            name="contact"
                            value={formData.contact}
                            onChange={handleChange}
                            className="form-control-modern"
                          />
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group controlId="email">
                          <Form.Label className="form-label-modern">Email</Form.Label>
                          <Form.Control
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            className={`form-control-modern ${emailError ? 'is-invalid' : ''}`}
                          />
                          {emailError && (
                            <Form.Text className="text-danger" style={{ fontSize: '0.7rem' }}>
                              {emailError}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>

                      <hr />

                      {/* Section Spirituelle */}
                      <Col md={12}>
                        <div className="section-title">
                          <i className="ri-heart-line"></i> Vie spirituelle
                        </div>
                      </Col>

                      <Col md={6}>
                        <Form.Group controlId="date_bapt_eau">
                          <Form.Label className="form-label-modern">Date baptême d'eau</Form.Label>
                          <Form.Control
                            type="date"
                            name="date_bapt_eau"
                            value={formData.date_bapt_eau}
                            onChange={handleChange}
                            className="form-control-modern"
                          />
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group controlId="date_bapt_saint">
                          <Form.Label className="form-label-modern">Date baptême du Saint-Esprit</Form.Label>
                          <Form.Control
                            type="date"
                            name="date_bapt_saint"
                            value={formData.date_bapt_saint}
                            onChange={handleChange}
                            className="form-control-modern"
                          />
                        </Form.Group>
                      </Col>

                      <hr />

                      {/* Section Formation */}
                      <Col md={12}>
                        <div className="section-title">
                          <i className="ri-graduation-cap-line"></i> Formation et consécration
                        </div>
                      </Col>

                      <Col md={6}>
                        <Form.Group controlId="form_seculiere">
                          <Form.Label className="form-label-modern">Formation séculière</Form.Label>
                          <Form.Control
                            type="text"
                            name="form_seculiere"
                            value={formData.form_seculiere}
                            onChange={handleChange}
                            className="form-control-modern"
                            placeholder="Diplôme, formation..."
                          />
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group controlId="form_eccle">
                          <Form.Label className="form-label-modern">Formation ecclésiastique</Form.Label>
                          <Form.Control
                            type="text"
                            name="form_eccle"
                            value={formData.form_eccle}
                            onChange={handleChange}
                            className="form-control-modern"
                            placeholder="Formation biblique..."
                          />
                        </Form.Group>
                      </Col>

                      <Col md={4}>
                        <Form.Group controlId="date_consecration">
                          <Form.Label className="form-label-modern">Date de consécration</Form.Label>
                          <Form.Control
                            type="date"
                            name="date_consecration"
                            value={formData.date_consecration}
                            onChange={handleChange}
                            className="form-control-modern"
                          />
                        </Form.Group>
                      </Col>

                      <Col md={4}>
                        <Form.Group controlId="lieu_affectation">
                          <Form.Label className="form-label-modern">Lieu d'affectation</Form.Label>
                          <Form.Control
                            type="text"
                            name="lieu_affectation"
                            value={formData.lieu_affectation}
                            onChange={handleChange}
                            className="form-control-modern"
                            placeholder="Lieu d'affectation"
                          />
                        </Form.Group>
                      </Col>

                      <Col md={4}>
                        <Form.Group controlId="fonct_org">
                          <Form.Label className="form-label-modern">Fonction dans l'organisation</Form.Label>
                          <Form.Control
                            type="text"
                            name="fonct_org"
                            value={formData.fonct_org}
                            onChange={handleChange}
                            className="form-control-modern"
                            placeholder="Fonction"
                          />
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group controlId="date_depart">
                          <Form.Label className="form-label-modern">Date de départ à la retraite</Form.Label>
                          <Form.Control
                            type="date"
                            name="date_depart"
                            value={formData.date_depart}
                            onChange={handleChange}
                            className="form-control-modern"
                          />
                          <Form.Text className="form-text-modern">
                            À calculer automatiquement (naissance + 70 ans)
                          </Form.Text>
                        </Form.Group>
                      </Col>

                      {/* Boutons */}
                      <Col md={12} className="mt-3">
                        <div className="d-flex gap-2 justify-content-end border-top pt-3">
                          <Button
                            variant="outline-secondary"
                            size="sm"
                            className="btn-modern-outline"
                            onClick={() => navigate(`/membres/${id}`)}
                          >
                            Annuler
                          </Button>
                          <Button
                            type="submit"
                            variant="primary"
                            size="sm"
                            className="btn-modern-success"
                            disabled={loading}
                          >
                            {loading ? (
                              <><Spinner size="sm" className="me-1" /> Enregistrement...</>
                            ) : (
                              <><i className="ri-check-line"></i> Enregistrer les modifications</>
                            )}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Footer />
        </div>
      </div>
    </>
  );
}